import React, { useState, useEffect } from "react";

const InputWithTick = ({ id, defaultValue, onUpdateValue }) => {
  const [inputValue, setInputValue] = useState(defaultValue || "");
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    setShowButton(false);
  }, [defaultValue]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    if (defaultValue !== value) {
      setShowButton(true);
    }
  };

  const handleButtonClick = () => {
    onUpdateValue(inputValue);
    if (inputValue === "") {
      setShowButton(false);
    }
  };

  return (
    <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
      <input
        id={id}
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        style={{ flexGrow: 1, marginRight: showButton ? "5px" : "0" }}
      />
      {showButton && (
        <button
          onClick={handleButtonClick}
          style={{
            padding: "0",
            border: "none",
            height: "100%",
            width: "10%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            fill="green"
            className="bi bi-check-square-fill"
            viewBox="0 0 16 16"
            title="Change"
            style={{ cursor: "pointer" }}
            onClick={() => {}}
          >
            <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm10.03 4.97a.75.75 0 0 1 .011 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.75.75 0 0 1 1.08-.022z" />
          </svg>
        </button>
      )}
    </div>
  );
};

export default InputWithTick;



// WEBPACK FOOTER //
// ./src/mi-app/plugins/inputWithTickIcon.js